// extracted by mini-css-extract-plugin
module.exports = {"module":"Modal_module__3Mjbv","down":"Modal_down__GEpBc","formdiv":"Modal_formdiv__132_S","formchild":"Modal_formchild__10Ln9"};